import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Button, Form, Modal, Popconfirm, Input, AutoComplete, Icon, message, Tooltip } from 'antd'
import ReactTable from 'react-table'
import moment from 'moment'
import Loader from '../../common/Loader'
import { actions as jobSiteServiceOrderActions } from '../../../redux/modules/jobFunctions/jobSiteServiceOrderActions'
import { actions as serviceOrderTemplatesActions } from '../../../redux/modules/jobFunctions/serviceOrderTemplatesActions'
import { actions as tasksActions } from '../../../redux/modules/tasksActions'
import { actions as userActions } from '../../../redux/modules/userActions'
import ServiceOrderEditor from '../../../components/service_order/ServiceOrderEditor'
import {
  filterCaseInsensitive,
  convertToOption,
  convertNamesToOption,
  arrayMove,
  getModalId
} from '../../../util'
import config from '../../../config'
import _ from 'lodash'
import history from '../../../history'

const { API_BASE } = config
const FormItem = Form.Item
const { TextArea } = Input
const propTypes = {}

class JobSiteServiceOrders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      contentData: null,
      serviceOrderItems: []
    }

    this.props.jobSiteServiceOrdersRefresh({
      jobId: this.props.jobId,
      next: (payload, err) => {
        const changeOrderId = getModalId(this.props.location.pathname)
        if (changeOrderId) {
          if (!err) {
            const results = _.get(payload, 'data')
            const current = _.find(results, { id: parseInt(changeOrderId, 10) })
            if (current) {
              setTimeout(() => this.handleRowClick(current), 500)
            } else {
              message.warning('This Purchase Order was deleted or does not exist.')
            }
          }
        }
      }
    })
    this.props.getAllTasks()
    this.props.getServiceOrderTemplates()
    this.props.getUsers()
  }

  componentDidUpdate(prevProps) {
    if (
      _.get(prevProps, 'serviceOrderTemplatesActions.serviceOrderTemplateItems') !==
      _.get(this.props, 'serviceOrderTemplatesActions.serviceOrderTemplateItems')
    ) {
      this.setState({
        serviceOrderItems: this.props.serviceOrderTemplatesActions.serviceOrderTemplateItems.data
      })
    }

    if (
      _.get(prevProps, 'jobSiteServiceOrderActions.jobSiteServiceOrdersItems') !==
      _.get(this.props, 'jobSiteServiceOrderActions.jobSiteServiceOrdersItems')
    ) {
      this.setState({
        serviceOrderItems: this.props.jobSiteServiceOrderActions.jobSiteServiceOrdersItems.data
      })
    }
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      delete values.created_by
      delete values.updated_by
      if (this.state.currentId === 0) {
        this.props.createServiceOrder({
          jobId: this.props.jobId,
          content: values,
          serviceOrderItems: this.state.serviceOrderItems,
          userId: this.props.user.userId
        })
      } else {
        if (isNaN(values.assigned_to_id)) {
          values.assigned_to_id = this.props.userActions.users.data.filter(
            item => `${item.first_name} ${item.last_name}` === values.assigned_to_id
          )[0].id
        }
        if (!Number.isInteger(values.service_order_template_id)) {
          values.service_order_template_id = this.state.contentData.service_order_template_id
        }
        this.props.updateServiceOrder({
          serviceOrderId: this.state.currentId,
          jobId: this.props.jobId,
          content: values,
          serviceOrderItems: this.state.serviceOrderItems,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      const { jobId, jobType } = this.props.match.params
      history.push(`/jobView/${jobId}/${jobType}/service-orders`)
      this.setState({ contentData: null, currentId: 0 })
    })
  }

  handleRowClick = row => {
    this.setState({
      currentId: row.id,
      contentData: row
    })
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/service-orders/modal/${row.id}`)
    this.props.getServiceOrderItems(row.id)
  }

  handleAddButton = () => {
    this.props.form.resetFields()
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/service-orders/modal/0`)
    this.setState({
      currentId: 0,
      contentData: null,
      serviceOrderItems: []
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/service-orders`)
    this.setState({
      currentId: 0,
      contentData: null,
      serviceOrderItems: [],
      addTaskName: ''
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteServiceOrder({
      jobId: this.props.jobId,
      serviceOrderId: this.state.currentId
    })

    form.resetFields()
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/service-orders`)
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false,
      serviceOrderItems: []
    })
  }

  handleItemsChange = serviceOrderItems => {
    this.setState({
      serviceOrderItems
    })
  }

  handleInputChange = (value, key, column) => {
    const groupedItems = this.state.serviceOrderItems.map(row => {
      if (row.id === key) row[column] = value
      return row
    })
    this.setState({
      serviceOrderItems: groupedItems
    })
  }

  editChangeOrderRow = rowId => {
    const groupedItems = this.state.serviceOrderItems.map(row => {
      if (row.id === rowId) row.isEditingRow = true
      return row
    })
    this.setState({
      serviceOrderItems: groupedItems
    })
  }

  saveChangeOrderRow = rowId => {
    const groupedItems = this.state.serviceOrderItems.map(row => {
      if (row.id === rowId) {
        row.isEditingRow = false
      }
      return row
    })
    this.setState({
      serviceOrderItems: groupedItems
    })
  }

  deleteChangeOrderRow = rowId => {
    const groupedItems = this.state.serviceOrderItems.filter(item => item.id !== rowId)

    this.setState({
      serviceOrderItems: groupedItems
    })
  }

  handleAddTaskInputChange = value => {
    const selectedTask = this.props.tasksActions.allTasks.data.filter(
      row => parseInt(row.id, 0) === parseInt(value, 0)
    )
    if (selectedTask.length > 0) {
      this.setState({
        addTaskInput: value,
        addTaskName: selectedTask[0].name
      })
    } else {
      this.setState({
        addTaskInput: value,
        addTaskName: value
      })
    }
  }

  handleAddDeviceNumberInputChange = value => {
    this.setState({
      addDeviceNumberInput: value
    })
  }

  handleAddNotesInputChange = value => {
    this.setState({
      addNotesInput: value
    })
  }

  handleAddMaterialsNeededInputChange = value => {
    this.setState({
      addMaterialsNeededInput: value
    })
  }

  handleAddItemClick = () => {
    const groupedItems = this.state.serviceOrderItems

    if (
      _.isEmpty(this.state.addTaskInput) ||
      _.isEmpty(this.state.addDeviceNumberInput) ||
      _.isEmpty(this.state.addNotesInput)
    ) {
      message.warning('You need to fill all item informations.')
    } else {
      const taskId = `item_${groupedItems.length + 1}`
      groupedItems.push({
        task_id: this.state.addTaskInput,
        task_name: this.state.addTaskName,
        device_number: this.state.addDeviceNumberInput,
        notes: this.state.addNotesInput,
        materials_needed: this.state.addMaterialsNeededInput,
        id: taskId
      })
      this.setState({
        serviceOrderItems: groupedItems,
        addTaskInput: '',
        addTaskName: '',
        addDeviceNumberInput: '',
        addNotesInput: '',
        addMaterialsNeededInput: ''
      })
    }
  }

  handleTemplateChange = event => {
    const form = this.props.form
    const selectedTemplate = this.props.serviceOrderTemplatesActions.serviceOrderTemplates.data.filter(
      row => parseInt(row.id, 0) === parseInt(event, 0)
    )
    if (selectedTemplate.length > 0) {
      this.props.getServiceOrderTemplateItems(selectedTemplate[0].id)
      form.setFieldsValue({
        description: selectedTemplate[0].description,
        service_order_template_id: selectedTemplate[0].id
      })
    }
  }

  markTaskComplete = taskId => {
    console.log(taskId)

    this.setState(prevState => {
      const taskIndex = prevState.serviceOrderItems.findIndex(task => task.id === taskId)
      let prevItems = [...prevState.serviceOrderItems]
      prevItems[taskIndex].completed = 1
      return { serviceOrderItems: prevItems }
    })

    this.props.markTaskComplete({
      jobId: this.props.jobId,
      taskId: taskId,
      serviceOrderId: this.state.currentId
    })
  }

  handleItemUp = taskId => {
    const { serviceOrderItems } = this.state
    const taskIndex = serviceOrderItems.findIndex(task => task.id === taskId)
    const sortedItemDataStructure = arrayMove(serviceOrderItems, taskIndex, taskIndex - 1)

    this.setState({
      serviceOrderItems: sortedItemDataStructure
    })
  }

  handleItemDown = taskId => {
    const { serviceOrderItems } = this.state
    const taskIndex = serviceOrderItems.findIndex(task => task.id === taskId)
    const sortedItemDataStructure = arrayMove(serviceOrderItems, taskIndex, taskIndex + 1)

    this.setState({
      serviceOrderItems: sortedItemDataStructure
    })
  }

  handleQuickAddTask = task => {
    this.props.quickAddTask({
      task: task,
      userId: this.props.user.userId
    })
  }

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  render() {
    const { contentData } = this.state
    const { getFieldDecorator } = this.props.form

    const jobSiteServiceOrders = _.get(
      this.props,
      'jobSiteServiceOrderActions.jobSiteServiceOrders'
    )

    if (!jobSiteServiceOrders) {
      return <Loader />
    }
    return (
      <div>
        {this.shouldRenderModal() && (
          <Modal
            visible={true}
            title="Service Orders"
            okText={contentData ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancel}
            onOk={this.handleCreate}
            width={1020}
            maskClosable={false}
          >
            <Form layout="vertical">
              {contentData && (
                <div className="row">
                  <div className="col-md-12 text-right">
                    <a
                      href={`${API_BASE}/api/job/job_site_service_orders/print/${contentData.id}`}
                      target="_blank"
                    >
                      <Button icon="printer" className="marginRight10" />
                    </a>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Template">
                    {getFieldDecorator('service_order_template_id', {
                      initialValue: contentData ? contentData.template_name : ''
                    })(
                      <AutoComplete
                        dataSource={convertToOption(
                          this.props.serviceOrderTemplatesActions &&
                            this.props.serviceOrderTemplatesActions.serviceOrderTemplates &&
                            this.props.serviceOrderTemplatesActions.serviceOrderTemplates.data
                        )}
                        filterOption={(inputValue, option) =>
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        }
                        onChange={this.handleTemplateChange}
                      >
                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                      </AutoComplete>
                    )}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Requested By">
                    {getFieldDecorator('requested_by', {
                      rules: [
                        {
                          required: true,
                          message: 'Requested by cannot be blank.'
                        }
                      ],
                      initialValue: contentData ? contentData.requested_by : ''
                    })(<Input />)}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Assigned To">
                    {getFieldDecorator('assigned_to_id', {
                      rules: [
                        {
                          required: true,
                          message: 'Assigned to cannot be blank.'
                        }
                      ],
                      initialValue: contentData
                        ? `${contentData.assigned_to_first_name} ${
                            contentData.assigned_to_last_name
                          }`
                        : ''
                    })(
                      <AutoComplete
                        dataSource={convertNamesToOption(
                          this.props.userActions &&
                            this.props.userActions.users &&
                            this.props.userActions.users.data
                        )}
                        filterOption={(inputValue, option) =>
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        }
                      >
                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                      </AutoComplete>
                    )}
                  </FormItem>
                </div>
              </div>
              {contentData && (
                <div className="row">
                  <div className="col-md-6">
                    <FormItem label="Created By">
                      {getFieldDecorator('created_by', {
                        initialValue: contentData
                          ? `${contentData.created_by_first_name} ${
                              contentData.created_by_last_name
                            }`
                          : ''
                      })(<Input disabled={true} />)}
                    </FormItem>
                  </div>
                  <div className="col-md-6">
                    <FormItem label="Updated By">
                      {getFieldDecorator('updated_by', {
                        initialValue: contentData
                          ? `${contentData.updated_by_first_name} ${
                              contentData.updated_by_last_name
                            }`
                          : ''
                      })(<Input disabled={true} />)}
                    </FormItem>
                  </div>
                </div>
              )}
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  initialValue: contentData ? contentData.description : ''
                })(<TextArea placeholder="Describe the attachment..." rows={4} />)}
              </FormItem>
              <ServiceOrderEditor
                allTasks={
                  this.props.tasksActions &&
                  this.props.tasksActions.allTasks &&
                  this.props.tasksActions.allTasks.data
                }
                serviceOrderItems={this.state.serviceOrderItems}
                handleItemsChange={this.handleItemsChange}
                editRow={this.editChangeOrderRow}
                saveRow={this.saveChangeOrderRow}
                deleteRow={this.deleteChangeOrderRow}
                handleItemUp={this.handleItemUp}
                handleItemDown={this.handleItemDown}
                handleAddTaskInputChange={this.handleAddTaskInputChange}
                handleAddDeviceNumberInputChange={this.handleAddDeviceNumberInputChange}
                handleAddNotesInputChange={this.handleAddNotesInputChange}
                handleAddMaterialsNeededInputChange={this.handleAddMaterialsNeededInputChange}
                handleAddItemClick={this.handleAddItemClick}
                handleInputChange={this.handleInputChange}
                addTaskInput={this.state.addTaskInput}
                addTaskName={this.state.addTaskName}
                addDeviceNumberInput={this.state.addDeviceNumberInput}
                addNotesInput={this.state.addNotesInput}
                addMaterialsNeededInput={this.state.addMaterialsNeededInput}
                nextStep={() => this.nextStep()}
                prevStep={() => this.prevStep()}
                isNew={!contentData}
                markTaskComplete={this.markTaskComplete}
                handleQuickAddTask={this.handleQuickAddTask}
              />
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={this.confirmDelete}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                {contentData && <Button type="danger" icon="delete" />}
              </Popconfirm>
            </Form>
          </Modal>
        )}
        <div className="jobsBar">
          Service Order
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Order
            </div>
          </div>
        </div>
        {this.props.jobSiteServiceOrderActions.jobSiteServiceOrders && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.jobSiteServiceOrderActions.jobSiteServiceOrders.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Number',
                    accessor: 'number',
                    maxWidth: 90,
                    filterable: false
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Completed',
                    className: 'textAlignCenter',
                    Cell: row => {
                      if (row.original.completed === 0) {
                        return <Icon type="close-circle" />
                      }
                      if (row.original.completed === 1) {
                        return <Icon type="check-circle-o" />
                      }
                    },
                    maxWidth: 90,
                    filterable: false
                  },
                  {
                    Header: 'Completed Date',
                    id: 'completed_date',
                    accessor: d => {
                      if (moment(d.completed_date).isValid() && d.completed) {
                        return moment(d.completed_date, 'YYYY-MM-DD hh:mm:ss').format(
                          'M/D/YYYY h:mm:ssa'
                        )
                      } else {
                        return 'Not yet complete'
                      }
                    },
                    maxWidth: 200
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    Cell: d => (
                      <Tooltip
                        title={`${d.original.created_by_first_name} ${
                          d.original.created_by_last_name
                        }`}
                      >{`${d.original.created_by_first_name} ${
                        d.original.created_by_last_name
                      }`}</Tooltip>
                    )
                  },
                  {
                    Header: 'Updated by',
                    id: 'updated_by',
                    Cell: d => (
                      <Tooltip
                        title={`${d.original.updated_by_first_name} ${
                          d.original.updated_by_last_name
                        }`}
                      >{`${d.original.updated_by_first_name} ${
                        d.original.updated_by_last_name
                      }`}</Tooltip>
                    )
                  }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: 'id',
                desc: true
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (
  { jobSiteServiceOrderActions, tasksActions, serviceOrderTemplatesActions, userActions },
  ownProps
) => ({
  jobSiteServiceOrderActions,
  tasksActions,
  serviceOrderTemplatesActions,
  userActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(
      {},
      tasksActions,
      jobSiteServiceOrderActions,
      serviceOrderTemplatesActions,
      userActions
    ),
    dispatch
  )
})

JobSiteServiceOrders.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSiteServiceOrders))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteServiceOrders.js